module.exports = __webpack_public_path__ + "static/media/bg-new-home.7e2658d5.png";